
import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import "./construccion.scss"
const Image = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "logo.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 50) {
            ...GatsbyImageSharpFluid
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)

  return <Img fluid={data.placeholderImage.childImageSharp.fluid}
  fadeIn={false} className="Logo"/>
}


const Construccion = () => (<div className="text-center">
  <Image/>
  <h1>Sitio en Construccion.</h1>
</div>)

export default Construccion